<template>
  <b-modal
    v-bind="$attrs"
    v-on="$listeners"
    :title="$t(!mutltiTab ? 'Prueba de entrega' : 'Verificar comprobantes')"
    :ok-title="$t('Cerrar')"
    size="lg"
    ok-variant="outline-secondary"
    ok-only
    no-close-on-esc
    no-close-on-backdrop
    no-footer
    v-if="proof"
  >
    <b-container>
      <b-row>
        <b-col>
          <b-row v-for="(proof, index) in infoProof" :key="index" align-v="center" class="p-1">
            <media-info v-bind="proof"></media-info>
          </b-row>
        </b-col>
        <b-col cols="8">
          <section v-if="!mutltiTab">
            <b-row v-for="(proof, index) in imgsProof" :key="index" align-v="center" class="p-1">
              <b-link
                :href="proof"
                target="_black"
                style="cursor: zoom-in"
              >
                <b-img thumbnail fluid :src="proof" :alt="'image'+index"/>
              </b-link>
            </b-row>
          </section>
          <section v-else>
            <b-tabs>
              <b-tab :title="$t('Prueba de recolección')" v-if="proof.collected">
                <b-row v-for="(colection, index) in recoProof" :key="index" align-v="center" class="p-1">
                  <b-link
                    v-if="colection"
                    :href="colection"
                    target="_black"
                    style="cursor: zoom-in"
                  >
                    <b-img thumbnail fluid :src="colection" :alt="'image'+index"/>
                  </b-link>
                </b-row>
              </b-tab>
              <b-tab :title="$t('Prueba de entrega')" v-if="imgsProof">
                <b-row v-for="(proof, index) in imgsProof" :key="index" align-v="center" class="p-1">
                  <b-link
                    v-if="proof"
                    :href="proof"
                    target="_black"
                    style="cursor: zoom-in"
                  >
                    <span v-if="isWebLink">Accede al contenido a través del siguiente enlace.</span>
                    <b-img v-else thumbnail fluid :src="proof" :alt="'image'+index"/>
                  </b-link>
                </b-row>
              </b-tab>
            </b-tabs>
          </section>
        </b-col>
      </b-row>
    </b-container>
  </b-modal>
</template>
<script>
import { BLink, BContainer } from 'bootstrap-vue'
export default {
  name: 'proof-modal',
  components: { BLink, BContainer },
  inheritAttrs: false,
  props: {
    proof: { type: Object, default: () => ({}) },
    mutltiTab: { type: Boolean, default: false },
    country_code: { type: String, default: 'cl'}
  },
  data () {
    return {
      infoProof: [],
      imgsProof: [],
      recoProof: [],
      isWebLink: false
    }
  },
  watch: {
    proof () {
      this.generateInfoProof(this.proof)
    }
  },
  mounted () {
    this.generateInfoProof(this.proof)
  },
  methods: {
    generateInfoProof (proof) {
      this.isWebLink = this.proof?.type === 'carrier_website'
      const tralations = this.$i18nImport(`${this.country_code || 'cl'}.es`)[`${this.country_code || 'cl'}.es`]
      this.infoProof = [
        {
          icon: 'CreditCardIcon',
          variant: 'light-warning',
          title: `${tralations.ID_NAME} de receptor`,
          content: proof?.recipient_dni || this.$t('Sin información')
        },
        {
          icon: 'UserCheckIcon',
          variant: 'light-warning',
          title: this.$t('Nombre de receptor'),
          content: proof?.recipient_name || this.$t('Sin información')
        },
        {
          icon: 'CalendarIcon',
          variant: 'light-warning',
          title: this.$t('Fecha'),
          content: proof?.date || this.$t('Sin información')
        }
      ]
      this.imgsProof = this.splitOrWrap(proof?.carier_url)
      if (proof?.collected?.img_url && this.mutltiTab) this.recoProof = this.splitOrWrap(proof?.collected?.img_url)
    },
    splitOrWrap(data, separator = ',') {
      if (data?.indexOf(separator) > -1) {
        return data.split(separator)
      }
      return [data]
    }
  }
}
</script>
